import { createSelector } from '@reduxjs/toolkit';
import { ApplicationState } from '../store';

export const interestsSelector = (state: ApplicationState) => state.interests;

export const userInterestsSelector = createSelector(
  interestsSelector,
  (interests) => interests.interests || []
);
